import React from "react";
import { useParams } from "react-router-dom";
import AddCategory from "./Operations/AddCategory";
import AddSubcategory from "./Operations/AddSubcategory";
import AddProduct from "./Operations/AddProduct";

export const CATEGORY = "category";
export const SUBCATEGORY = "subcategory";
export const PRODUCT = "product";

function AdminPanelOperations() {
  let { entity } = useParams();

  if (entity === CATEGORY) return <AddCategory />;
  if (entity === SUBCATEGORY) return <AddSubcategory />;
  if (entity === PRODUCT) return <AddProduct />;
}

export default AdminPanelOperations;
